import { useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import { mensajeError, soloDigitos } from './acceso';

// Cada vez que se entra: el código de 6 números de la app de códigos.
export function Codigo({ sb, onListo }: { sb: SupabaseClient; onListo: () => void }) {
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const verificar = async (e: Event) => {
    e.preventDefault();
    setError('');
    if (codigo.length !== 6) { setError('El código tiene 6 números.'); return; }
    setEnviando(true);
    const { data, error: errLista } = await sb.auth.mfa.listFactors();
    const factor = data?.totp.find(f => f.status === 'verified');
    if (errLista || !factor) { setEnviando(false); setError(mensajeError(errLista || { message: 'No se encontró tu app de códigos.' })); return; }
    const { error } = await sb.auth.mfa.challengeAndVerify({ factorId: factor.id, code: codigo });
    setEnviando(false);
    if (error) { setError(mensajeError(error)); setCodigo(''); return; }
    onListo();
  };
  return (
    <form class="panel form" onSubmit={verificar} aria-label="Código de verificación">
      <h2>Código de verificación</h2>
      <p>Abre tu app de códigos (1Password, Contraseñas de Apple o Google Authenticator) y escribe el número de 6 dígitos de <b>Talentino</b>.</p>
      <label for="codigo">Código</label>
      <input id="codigo" class="in codigo" inputMode="numeric" autocomplete="one-time-code" maxLength={6} value={codigo} onInput={e => setCodigo(soloDigitos(e.currentTarget.value))} />
      {error && <p class="error" role="alert">{error}</p>}
      <button class="btn primary" type="submit" disabled={enviando}>{enviando ? 'Verificando…' : 'Verificar'}</button>
      <button class="btn link" type="button" onClick={() => sb.auth.signOut()}>Salir</button>
    </form>
  );
}
